import Control from "@/Controls/Control";
import WebComponentBinding from "@/Infrastructure/CustomBindings/WebComponentBinding";
import WebComponentControlViewModel from "@/Components/WebComponents/WebComponentControlViewModel";
import { WebComponentBindingOptions } from "#/CoreFrameInterfaces";
import ComponentManager from "@/Management/ComponentManager";

export interface IWebComponentControlConstructorParameters<TOriginalComponent = unknown> {
    tagName: string;
    bindingOptions: WebComponentBindingOptions<TOriginalComponent>;
}

export default class WebComponentControl<TOriginalComponent = unknown> extends Control {
    protected tagName: IWebComponentControlConstructorParameters<TOriginalComponent>['tagName'];
    protected bindingOptions: IWebComponentControlConstructorParameters<TOriginalComponent>['bindingOptions'];

    constructor(params: IWebComponentControlConstructorParameters<TOriginalComponent>, viewModel: WebComponentControlViewModel) {
        super(viewModel);

        this.tagName = params.tagName;
        this.bindingOptions = params.bindingOptions;
    }

    public getControl(): JQuery {
        return WebComponentBinding.createElement(this.tagName, this.bindingOptions);
    }
}

ComponentManager.setControl('WebComponentControl', WebComponentControl, 'RADPresentation.HTMLClient.DefaultViewExtensions')
